import { fromPairs, map } from 'lodash/fp'

export const prepareValues = (ids: string[]) =>
	fromPairs(map((id: string) => [id, ''], ids || []))
